import { History } from 'history';
import { useHistory, useParams } from 'react-router-dom';

interface Params {
  [key: string]: string;
}
export interface PortalNavigation {
  pathname: History.Pathname;
  locationState: History.LocationState;
  params: Params;
  query: string;
  push: (route: string) => void;
  replace: (route: string) => void;
}

export const useNavigation = (): PortalNavigation => {
  const history: History = useHistory();
  const params: Params = useParams();
  return {
    pathname: history.location.pathname,
    locationState: history.location.state,
    query: history.location.search,
    params,
    push: history.push,
    replace: history.replace,
  };
};
